export default __webpack_public_path__ + "static/media/women.5a11b513.png";